// stores/vehicleAccessStore.js
'use client';

import { mutate } from 'swr';
import { fleetApi } from '../api/axiosClient';

const getTzParam = () => `?tz=${Math.abs(new Date().getTimezoneOffset() / 60)}`;

export const revalidateVehicleAccessList = () => {
  mutate((key) => Array.isArray(key) && key[0] === '/user-vehicle-access/search');
};

export const assignVehicleAccess = async (userId, vehicleIds = []) => {
  if (userId == null) throw new Error('userId is required');
  if (!Array.isArray(vehicleIds)) throw new Error('vehicleIds must be an array');

  try {
    const data = vehicleIds.map((v) => ({ user_access: Number(userId), vehicle_access: Number(v) }));
    const body = { data };
    const response = await fleetApi.post(`/assign-vehicle-access/add${getTzParam()}`, body);
    revalidateVehicleAccessList();
    return response?.data ?? null;
  } catch (error) {
    console.error('Failed to assign vehicle access:', {
      userId,
      vehicleIds,
      status: error?.response?.status,
      responseData: error?.response?.data,
      message: error?.message
    });
    throw error;
  }
};

export const updateVehicleAccess = async (userId, vehicleIds = []) => assignVehicleAccess(userId, vehicleIds);
